import { Link } from 'react-router-dom';
import { genres } from '@/mocks/manhwa';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-medium tracking-widest text-accent-600 mb-2">六大题材导航</p>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">按题材快速定位韩漫</h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg">
              恋爱、都市、奇幻、校园、悬疑、热血六大分类，每类都经过精心整理，帮你第一时间找到想看的韩漫。
            </p>
          </div>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            浏览全部题材 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {genres.map((g) => (
            <Link
              key={g.id}
              to={`/category/${g.id}`}
              className="group bg-background-50 border border-background-200 rounded-2xl p-5 md:p-6 hover:border-primary-300 hover:-translate-y-1 transition-all"
            >
              <span className="w-12 h-12 rounded-xl bg-primary-100 text-primary-700 flex items-center justify-center mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${g.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-medium text-foreground-950 text-base">{g.name}韩漫</h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">{g.desc}</p>
              <p className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                <span className="font-display-latin text-base">{g.count}</span> 部收录
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}